import { useCallback } from "react";
import {
  uploadToADLS,
  formatCorrectionFieldLabel,
  formatCorrectionFromTo,
} from "../components/VABondRetrieveShared";
import { buildVaPayload } from "../bondRetrievalPayloadBuilders";
import { calculatePremium } from "../../../../globals/utils/commons";
import useBondRetrieveBase from "./useBondRetrieveBase";

function useVABondRetrieve() {
  const buildPayload = useCallback(
    (globalState, status, billingMethod, isIndemnityReceived) =>
      buildVaPayload(globalState, billingMethod, isIndemnityReceived, status),
    []
  );

  return useBondRetrieveBase("va", {
    buildPayload,
    calculateCorrectionPremium: (amount) => calculatePremium(amount),
    extraReturn: () => ({
      uploadToADLS,
      formatCorrectionFieldLabel,
      formatCorrectionFromTo,
    }),
  });
}

export default useVABondRetrieve;
